import { Modal } from "antd";

export const confirmLogout = (onConfirm: () => void | Promise<void>) => {
  Modal.confirm({
    centered: true,
    title: "Đăng xuất khỏi tài khoản?",
    content: "Bạn sẽ cần đăng nhập lại để xem hồ sơ và lịch sử đơn hàng.",
    okText: "Đăng xuất",
    cancelText: "Ở lại",
    okButtonProps: {
      danger: true,
    },
    onOk: () => onConfirm(),
  });
};
